//extracted by mini-css-extract-plugin
export default {"notificationsPanel":"styles_notificationsPanel__gtG2-","notificationsPanelHeader":"styles_notificationsPanelHeader__wyz9U","panelTitle":"styles_panelTitle__+kkIC"};;